import { useCreditsAccountInfo, useSession } from 'src/hooks';
import { useGetAPIUsagesQuery } from 'src/store/services';
import { useMemo } from 'react';

type UseAPIUsagesProps = {
  nextKey: string;
  prevKey: string;
};

export const useAPIUsages = ({ nextKey, prevKey }: UseAPIUsagesProps) => {
  const {
    appUser: { user_id },
  } = useSession();
  const { creditAccountInfo, isCreditAccountInfoLoading } =
    useCreditsAccountInfo();

  const { data, isLoading, isFetching } = useGetAPIUsagesQuery(
    {
      user_id,
      account_id: creditAccountInfo?.account_id || '',
      next_page_token: nextKey,
      previous_page_token: prevKey,
    },
    { skip: !user_id || !creditAccountInfo?.account_id },
  );

  return useMemo(
    () => ({
      usagesData: data?.transactions || [],
      isLoading: isLoading || isCreditAccountInfoLoading,
      isFetching,
      nextPageToken: data?.next_evaluated_key || '',
      previousPageToken: data?.previous_page_token || '',
    }),
    [data, isLoading, isCreditAccountInfoLoading, isFetching],
  );
};
